import { DynamicFormV2Palette } from "@mui/material";

export type FormDialogComponentTokenType = {
  textColor: string;
  titleColor: string;
  backgroundColor: string;
  iconColor: string;
  iconBackgroundColor: string;
};

export const assignDialogComponentTokens = (formsPalette: DynamicFormV2Palette["forms"], isDullMode: boolean) => {
  return {
    textColor: formsPalette.text.moderate,
    titleColor: formsPalette.text.intense,
    backgroundColor: formsPalette.surface.reverse,
    iconColor: formsPalette.text.brand,
    iconBackgroundColor: isDullMode ? formsPalette.surface.quiet : formsPalette.surface.supershy,
  } as FormDialogComponentTokenType;
};
